import pushToDataLayer, {
  CartTypeQuantityData,
  PushEventType,
  TrackingEvent
} from './pushToDataLayer';

export enum SessionActionType {
  SESSION = 'session',
  LOGIN = 'login',
  LOGOUT = 'logout'
}

type SessionType = {
  readonly type: SessionActionType.SESSION;
};

type LoginType = {
  readonly type: SessionActionType.LOGIN;
};

type LogoutType = {
  readonly type: SessionActionType.LOGOUT;
};

export type TrackSessionActionsType = SessionType | LoginType | LogoutType;

const buildSessionEvent = (
  eventType: TrackSessionActionsType,
  anonymousId: string | null,
  authenticatedId: string | null,
  cart: CartTypeQuantityData
): PushEventType => {
  return {
    type: TrackingEvent.SESSION,
    event: eventType.type,
    anonymousId,
    authenticatedId,
    session: { cart }
  };
};

const trackSessionActions = (
  eventType: TrackSessionActionsType,
  anonymousId: string | null,
  authenticatedId: string | null,
  cartQuantityData: CartTypeQuantityData
): void => {
  const sessionEvent: PushEventType = buildSessionEvent(
    eventType,
    anonymousId,
    authenticatedId,
    cartQuantityData
  );

  pushToDataLayer(sessionEvent);
};

export default trackSessionActions;
